/*jshint -W040*/
(function () {
    'use strict';

    angular
        .module('app.region')
        .component('rmapBase', {
            bindings: {
                model: '<',
                mode: '<',
                onStateAdded: '&',
                onStateRemoved: '&',
                onSiteAdded: '&',
                onSiteRemoved: '&',
                onStateWithSitesAdded: '&',
                onStateWithSitesRemoved: '&'
            },
            templateUrl: 'app/region/dashboard/map/region.map.component.html',
            controller: regionMapBaseController,
            controllerAs: 'vm'
        });

    /* @ngInject */
    function regionMapBaseController($q, currentUser, leaflet, topojson, regionService) {
        this.$onInit = onInit;
        this.$onChanges = onChanges;

        var vm = this;

        var tileLayer = regionService.getLeafletTileLayer();
        var baseMapLayer = leaflet.tileLayer(tileLayer.url, {
            minZoom: tileLayer.minZoom,
            maxZoom: tileLayer.maxZoom,
            attribution: tileLayer.attribution
        });

        vm.map = undefined;
        vm.originalGeoData = {};
        vm.geodata = undefined;
        vm.areaGeoData = undefined;
        vm.statesWithSites = [];

        vm.centerMap = centerMap;

        function onInit() {
            loadGeoData();
        }

        function onChanges(changes) {
            if (changes) {
                if (changes.model) {
                    if (changes.model.currentValue.corporateid !== changes.model.previousValue.corporateid) {
                        getStatesWithSites(vm.model.corporateid);
                    }
                }
            }
        }

        function getGeoJson() {
            return regionService.getGeoJsonObject();
        }

        function getStatesWithSites(corporateid) {
            vm.areaGeoData = undefined;
            vm.statesWithSites = [];
            regionService.getStatesWithSites(corporateid).then(function (result) {
                if (result.status === 200) {
                    vm.statesWithSites = result.data;
                    createAreaGeoJson(vm.geodata);
                } else {
                    vm.statesWithSites = [];
                    vm.areaGeoData = undefined;
                    vm.onSiteCountChange({ count: 0 });
                }
            });
        }

        function createAreaGeoJson(geodata) {
            vm.areaGeoData = {
                features: [],
                type: 'FeatureCollection'
            };
            angular.forEach(geodata.features, function (feature) {
                angular.forEach(vm.statesWithSites, function (state) {
                    if (state.StateId === feature.properties.STATEID) {
                        vm.areaGeoData.features.push(feature);
                    }
                });
            });
        }

        function centerMap() {
            vm.map.setView([40, -100]);
            vm.map.setZoom(5);
        }

        function initializeMap() {
            vm.map = leaflet.map('map', {
                center: [40, -100],
                zoomSnap: 0.5,
                zoom: 5,
                doubleClickZoom: false,
                layers: [baseMapLayer]
            });
        }

        function loadGeoData() {
            getGeoJson().then(function (result) {
                if (result.status === 200) {
                    vm.originalGeoData = topojson.feature(result.data, result.data.objects.collection);
                    vm.geodata = angular.copy(vm.originalGeoData);
                    initializeMap();
                }
            });
        }
    }

})();
